import { render } from "./tournament_footer_section.vue?vue&type=template&id=15fa3737"
import script from "./tournament_footer_section.vue?vue&type=script&lang=js"
export * from "./tournament_footer_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__